import { request } from '@/common/utils/request'

// 获取商家信息
export function fetchShopDetailShopDetail(params) {
  return request.get({
    url: 'crm.bdapp.shop.getDetail',
    params,
  })
}

// 获取商机信息
export function fetchBizoppDetailShopDetail(params) {
  return request.get({
    url: 'crm.bdapp.bizopp.getBizoppInfo',
    params,
  })
}
// 以后不管是商机还是商家，都调用detail，后续会进行迭代优化
export function fetchDetail(params) {
  return request.get({
    url: 'crm.bdapp.store.detail',
    params,
  })
}

// 获取合同信息
export function fetchContractorDetailShopDetail(params) {
  return request.get({
    url: 'crm.bdapp.contractor.getContractorDetail',
    params,
  })
}

// 获取菜品
export function fetchDish(params) {
  return request.get({
    url: 'crm.bdapp.bizopp.getCategoryByCountry',
    params,
  })
}

// 获取平台来源
export function fetchPlatformList(params) {
  return request.get({
    url: 'crm.bdapp.bizopp.getPlatformList',
    params,
  })
}

// 标记问题门店
export function fetchBizoppUpdateTags(data) {
  return request.post('crm.bdapp.bizopp.updateTags', {
    data,
  })
}

// 更新门店POI
export function updateShopPOI(data) {
  return request.post('crm.bdapp.shop.shop.updatePoiGlobal', {
    data,
  })
}

// 获取开店检查项
export function fetchOpenCheck(params) {
  return request.get({
    url: 'crm.bdapp.bizopp.openCheck',
    params,
  })
}

export function setContractSignType(data) {
  return request.post('crm.bdapp.open.apply.setContractSignType', {
    data,
  })
}

export function payVerify(data) {
  return request.post('crm.bdapp.shop.payVerify', {
    data,
  })
}

export function bizoppPickIn(data) {
  return request.post('crm.bdapp.bizopp.distribution.bizoppPickIn', {
    data,
  })
}

export function bizoppGiveUp(data) {
  return request.post('crm.bdapp.bizopp.distribution.bizoppGiveUp', {
    data,
  })
}

export function getAbnormalTags(data) {
  return request.post('crm.bdapp.bizopp.distribution.getAbnormalTags', {
    data,
  })
}

export function getSaleDataByShopId(params) {
  return request.get({
    url: 'crm.bdapp.shop.getSaleData',
    params,
  })
}

// 获取商家绩效指标
export function getShopIndicators(params) {
  return request.get({
    url: 'feidian.perf.getShopIndicators',
    params,
  })
}

// 获取商家经营报告
export function getReportList(params) {
  return request.post({
    url: 'feidian.rsreports.getReportList',
    params,
  })
}

// 获取商家菜品列表
export function getItemList(params) {
  return request.post({
    url: 'feidian.rsreports.getItemList',
    params,
  })
}
// 获取营销活动数量
export function getPromoAmountByShopId(params) {
  return request.get({
    url: 'feidian.bdapp.promotion.getUnregisteredPlanCnt',
    params,
  })
}

// 获取优选好店入口是否展示
export function getDiDiTopInfoByShopId(params) {
  return request.get({
    url: 'feidian.bdapp.shop.getShopRights',
    params,
  })
}

// feidian的商家详情接口
export function getNewShopDetail(params) {
  return request.get({
    url: 'feidian.bdapp.shop.getDetail',
    params,
  })
}

// 获取灰度标识
export function getGrayFlag(params) {
  return request.get({
    url: 'feidian.common.getGrayFlag',
    params,
  })
}

// feidian商家详情把详情信息和按钮分开调用，因此增加此商家按钮接口
export function getDetailButton(params) {
  return request.get({
    url: 'crm.bdapp.shop.getDetailButton',
    params,
  })
}

// 获取商家评论统计
export function getEvaluationStatistics(params) {
  return request.get({
    url: 'feidian.bdapp.shop.getEvaluationStatistics',
    params,
  })
}

// 营销-招商活动预报名topic列表
export function getPreSignupList(params) {
  return request.get({
    url: 'feidian.bdapp.promotion.getPreSignupList',
    params,
  })
}

// 营销-招商活动预报名topic-特价菜分类列表
export function getSpecialCateList(params) {
  return request.get({
    url: 'feidian.bdapp.promotion.getSpecialCateList',
    params,
  })
}

// 营销-招商活动预报名topic-特价菜菜品列表
export function getSpecialItemList(params) {
  return request.get({
    url: 'feidian.bdapp.promotion.getSpecialItemList',
    params,
  })
}

// 获取当日打卡记录
export function getTodayCheckinLog(params) {
  return request.get({
    url: 'feidian.bdapp.visit.getTodayCheckinLog',
    params,
  })
}

// 签到签退打卡
export function visitCheckin(params) {
  return request.post(
    {
      url: 'feidian.bdapp.visit.checkin',
      params,
    },
    { showToast: false },
  )
}
